export const parseDateToEpoch = (value: unknown, boundary: 'start' | 'end' = 'start'): number | undefined => {
  if (!value) {
    return undefined;
  }

  if (value instanceof Date) {
    const normalized = new Date(value.getTime());
    if (boundary === 'start') {
      normalized.setHours(0, 0, 0, 0);
    } else {
      normalized.setHours(23, 59, 59, 999);
    }
    return Math.floor(normalized.getTime() / 1000);
  }

  if (typeof value === 'string') {
    const dateOnlyMatch = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (dateOnlyMatch) {
      const year = Number(dateOnlyMatch[1]);
      const monthIndex = Number(dateOnlyMatch[2]) - 1;
      const day = Number(dateOnlyMatch[3]);

      if (Number.isFinite(year) && Number.isFinite(monthIndex) && Number.isFinite(day)) {
        const localDate = boundary === 'start'
          ? new Date(year, monthIndex, day, 0, 0, 0, 0)
          : new Date(year, monthIndex, day, 23, 59, 59, 999);
        return Math.floor(localDate.getTime() / 1000);
      }
    }

    const parsedDate = new Date(value);
    if (Number.isFinite(parsedDate.getTime())) {
      if (boundary === 'start') {
        parsedDate.setHours(0, 0, 0, 0);
      } else {
        parsedDate.setHours(23, 59, 59, 999);
      }
      return Math.floor(parsedDate.getTime() / 1000);
    }
  }

  return undefined;
};
